import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import { Container } from '@mui/system';
import React from 'react';
import { Loading, useTranslate } from 'react-admin';
import { SettingModel } from '../../config/types/models/SettingModel';
import { useSaveSetting, useSetting } from '../../hooks/setting/useSetting';
import EmailSetting from './EmailSetting';
import GeneralSetting from './GeneralSetting';
import PaymentSetting from './PaymentSetting';
import S3Setting from './S3Setting';
import ShippingSetting from './ShippingSetting';

function SettingPage() {
  const t = useTranslate();
  const { setting, setSetting, isLoading } = useSetting();
  const { mutate } = useSaveSetting();

  const onSave = (setting: SettingModel | null) => {
    mutate(setting);
  };
  if (isLoading || setting === null) return <Loading />;
  return (
    <Container sx={{ padding: 2 }}>
      <Grid
        container
        spacing={2}
        sx={{
          padding: 2,
        }}
      >
        <Grid item lg={6} md={6} xs={12}>
          <Typography variant='h5'>{t('setting')}</Typography>
        </Grid>
        <Grid item lg={6} md={6} xs={12}>
          <Box sx={{ flexDirection: 'row-reverse', display: 'flex' }}>
            <Button onClick={() => onSave(setting)}>{t('save')}</Button>
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item lg={4} md={6} sm={12} xs={12} style={{ padding: 8 }}>
          <GeneralSetting setting={setting} setSetting={setSetting} />
          <EmailSetting setting={setting} setSetting={setSetting} />
        </Grid>

        <Grid item lg={4} md={6} sm={12} xs={12} style={{ padding: 8 }}>
          <PaymentSetting setting={setting} setSetting={setSetting} />
          <S3Setting setting={setting} setSetting={setSetting} />
        </Grid>

        <Grid item lg={4} md={6} sm={12} xs={12} style={{ padding: 8 }}>
          <ShippingSetting setting={setting} setSetting={setSetting} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default SettingPage;
